<template>
    <div v-if="!isMobile">
        <Popup v-model:show="showSettingBar"
            className="profile-popup-box-web"
            headerClassName="profile-popup-header-web">
            <AccountWeb 
                @handleEditNickname="handleShowCenterPopupEditNickname"
                @handleCloseSidebar="handleCloseSidebar"
                @handleInfo="handleInfo" />
        </Popup>

        <Popup v-model:show="showEditNickName"
            type="center"
            className="editnickname-popup-box-web"
            headerClassName="editnickname-popup-header-web">
            <div class="center-content">
                <MyProfile
                    @handleSaveProfile="handleHideCenterPopupEditNickname" />
            </div>
        </Popup>

        <Popup v-model:show="showAbout"
            type="center">
            <div class="center-content">
                <AccountInfo type="about" />
            </div>
        </Popup>

        <Popup v-model:show="showDisclaimer"
            type="center">
            <div class="center-content">
                <AccountInfo type="disclaimer" />
            </div>
        </Popup>

        <Popup v-model:show="showPolicy"
            type="center">
            <div class="center-content">
                <AccountInfo type="policy" />
            </div>
        </Popup>
    </div>
</template>

<script>
    import AccountWeb from '../../components/account/Web.vue'
    import MyProfile from '@/views/account/MyProfile.vue'
    import AccountInfo from './AccountInfo.vue'
    import { mapGetters } from 'vuex';
    export default {
        name: 'AccountWebPopup',
        data() {
            return {
                showSettingBar: false,
                showEditNickName: false,
                showAbout: false,
                showDisclaimer: false,
                showPolicy: false,
            }
        },
        components: {
            AccountWeb,
            MyProfile,
            AccountInfo
        },
        computed: {
            ...mapGetters([
                "isMobile",
                "isLogin"
            ])
        },
        methods: {
            handleShowSidePopupSettingList() {
                this.showSettingBar = !this.showSettingBar;
            },
            handleShowCenterPopupEditNickname() {
                this.showSettingBar = !this.showSettingBar;
                this.showEditNickName = !this.showEditNickName;
            },
            handleHideCenterPopupEditNickname() {
                this.showEditNickName = false;
            },
            handleCloseSidebar() {
                this.showSettingBar = false;
            },
            handleInfo(name) {
                switch(name) {
                    case 'ABOUT_ASPN':
                        this.showAbout = true
                        break;
                    case 'DISCLAIMER': 
                        this.showDisclaimer = true
                        break;
                    case 'PRIVACY_POLICY': 
                        this.showPolicy = true
                        break;
                }
                this.showSettingBar = false;
            }
        }
    }
</script>

<style>
.profile-popup-box-web {
  background-color: var(--color-background-default-default) !important;
}
.profile-popup-header-web {
  background-color: var(--color-background-default-secondary) !important;
}
.editnickname-popup-box-web {
  background-color: var(--color-background-default-secondary) !important;
  /* border-radius: 16px; */
  width: 400px !important;
}
.editnickname-popup-header-web {
    /* border-radius: 16px 16px 0 0; */
    background-color: var(--color-background-default-secondary) !important;
    justify-content: left;
    padding: 32px 32px 0 32px !important;
}
</style>

<style scoped>

.center-content {
    padding: 24px 32px 32px 32px;
}
</style>